// ManageUsers.js
import React, { useState } from "react";
import { Typography, Box } from "@mui/material";
import ManageUserCredits from "../dashboard/ManageUserCredits"; 
import ManageUserVMs from "../dashboard/ManageUserVMs";
import "../../../src/styles/Customer.scss";
import "../../../src/dist/css/style.min.css"
import "../../../src/index.css";

const ManageUsers = () => {
  const [selectedSection, setSelectedSection] = useState("credits");

  const handleTabClick = (section) => {
    setSelectedSection(section);
  };

  const renderSection = () => {
    switch (selectedSection) {
      case "credits":
        return <ManageUserCredits />;

      case "ec2":
        return <ManageUserVMs />;

      case "placeholder":
        return (
          <div style={{ marginTop: 32 }}>
            <Typography variant="h6" gutterBottom>
              Placeholder
            </Typography>
            <Typography style={{ fontSize: "14px", marginBottom: "16px" }}>
              This is a placeholder section. Use this area for future admin tools
              like organization settings, usage analytics, or audit logs.
            </Typography>
            <div className="page-wrapper overflow-hidden">
              <div
                style={{
                  padding: "20px",
                  borderRadius: "8px",
                  border: "1px solid #e0e0e0",
                  backgroundColor: "#fff",
                }}
              >
                <p style={{ fontSize: "14px", color: "#666" }}>
                  Add any future management features here.
                </p>
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="customer-page" style={{ padding: "20px 0", marginTop: "10px" }}>
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "20px",
          boxSizing: "border-box",
        }}
      >
        <Typography variant="h6" gutterBottom align="center">
          Welcome to the <br />
          <strong>Manage Users & Resources Dashboard!</strong>
        </Typography>

        <Typography
          align="center"
          style={{ fontSize: "14px", fontWeight: "normal", marginBottom: "30px" }}
        >
          Use the cards below to assign credits, manage EC2 instances, and plug in
          future admin tools.
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", marginLeft: "14px" }}>
          <Box sx={{ display: "flex", gap: 1 }}>
            {/* Manage Credits card */}
            <div
              className={`tab ${selectedSection === "credits" ? "active-tab" : ""}`}
              onClick={() => handleTabClick("credits")}
            >
              Manage Credits
              <br />
              <p style={{ fontSize: "13px", fontWeight: "normal" }}>
                Assign or update credits for individual users <br />
                or all users in an organization.
              </p>
            </div>

            {/* Manage EC2 Instances card */}
            <div
              className={`tab ${selectedSection === "ec2" ? "active-tab" : ""}`}
              onClick={() => handleTabClick("ec2")}
            >
              Manage EC2 Instances
              <br />
              <p style={{ fontSize: "13px", fontWeight: "normal" }}>
                View and control compute instances used for <br />
                training and inference workloads.
              </p>
            </div>

            {/* Placeholder card */}
            <div
              className={`tab ${selectedSection === "placeholder" ? "active-tab" : ""}`}
              onClick={() => handleTabClick("placeholder")}
            >
              Placeholder
              <br />
              <p style={{ fontSize: "13px", fontWeight: "normal" }}>
                Reserve this card for future admin tools <br />
                and advanced configuration panels.
              </p>
            </div>
          </Box>
        </Box>

        {/* Active section content */}
        <div>{renderSection()}</div>
      </div>
    </div>
  );
};

export default ManageUsers;
